import { computed, type ComputedRef } from 'vue'
import type { CountryIso } from 'src/types/country'

export default function useAgreementYdoc({
  countryIso,
  isDoctor,
  isLpu,
  isYdoc,
}: {
  countryIso: ComputedRef<Uppercase<CountryIso>>
  isDoctor: ComputedRef<boolean>
  isLpu: ComputedRef<boolean>
  isYdoc: ComputedRef<boolean>
}) {
  const registrationAgreementLink = computed(() => {
    if (countryIso.value === 'BY') {
      if (isDoctor.value) {
        return '/static/_v1/ydoc/documents/registration/registration-doctor-by.pdf'
      }

      if (isLpu.value) {
        return '/static/_v1/ydoc/documents/registration/registration-lpu-by.pdf'
      }
    }

    if (countryIso.value === 'KZ') {
      if (isDoctor.value) {
        return '/static/_v1/ydoc/documents/registration/registration-doctor-kz.pdf'
      }

      if (isLpu.value) {
        return '/static/_v1/ydoc/documents/registration/registration-lpu-kz.pdf'
      }
    }

    if (countryIso.value === 'KG') {
      if (isDoctor.value) {
        return '/static/_v1/ydoc/documents/registration/registration-doctor-kg.pdf'
      }
    }

    return ''
  })

  const isVisibleAgreementYdoc = computed(() => isYdoc.value && registrationAgreementLink.value)

  return {
    registrationAgreementLink,
    isVisibleAgreementYdoc,
  }
}
